import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { SlipDetails } from './DispatchSlipData';
import { fieldLabelStyle, slipLocationStyle, tableCellStyle, tableStyle, uppercaseMainText } from './styled';
type BodyCell = {
  title: string;
  text: string;
  isLocation?: boolean;
  colSpan?: number
}

export const DispatchSlip = ({
  slipDetails,
  page
}: { slipDetails: SlipDetails, page: number }) => {
  const bodyRows: BodyCell[][] = [
    [
      { title: slipDetails.location, text: '', isLocation: true },
      { title: 'Date:', text: slipDetails.orderDate }
    ],
    [
      { title: 'Ordered By:', text: '' },
      { title: 'Time:', text: '' }
    ],
    [
      { title: 'Ship:', text: slipDetails.vessel, colSpan: 2 },
    ],
    [
      { title: 'Pier:', text: slipDetails.dock, colSpan: 2 },
    ],
    [
      { title: 'Time Start:', text: slipDetails.details[page - 1]?.shiftStartTime || '', colSpan: 2 },
    ],
    [
      { title: 'Quantity Ordered:', text: `${slipDetails.quantityOrdered}` },
      { title: 'Job:', text: slipDetails.job }
    ]
  ]

  return (
    <TableContainer>
      <Table size="custom" sx={tableStyle} border={0}>
        <TableHead>
          {[slipDetails.title, slipDetails.subTitle].map((title: string, i: number) => (
            <TableRow key={i}>
              <TableCell
                align="center"
                colSpan={2}
                sx={(theme) => tableCellStyle(theme, slipDetails.slipColour)}
              >
                <Typography variant="body2" sx={uppercaseMainText}>
                  {title}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableHead>
        <TableBody>
          {bodyRows.map((row: BodyCell[], i: number) => (
            <TableRow key={i}>
              {
                row.map((cell, i) => (
                  <TableCell
                    colSpan={cell.colSpan}
                    sx={(theme) => tableCellStyle(theme, slipDetails.slipColour)}
                    key={i}
                  >
                    <Typography
                      variant={cell.isLocation ? "h6" : undefined}
                      sx={cell.isLocation ? slipLocationStyle : fieldLabelStyle}
                    >
                      {cell.title}
                    </Typography>
                    {cell.text}
                  </TableCell>
                ))
              }
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
